import { ArticleModel } from "../archive/article.model";
import { CostCenterPriceModel } from "../archive/cost-center-price.model";
import { OrderModel } from "./order.model";

export class OrderDetailModel {
  orderDetailId: number = 0;
  orderId: number = 0;
  order: OrderModel | null = null;
  articleId: number = 0;
  article: ArticleModel | null = null;
  quantityInitial: number = 0;
  quantityFinal: number = 0;
  quantityReserved: number = 0;
  quantityRemission: number = 0;
  baseUnitValue: number = 0;
  rateDiscount: number = 0;
  unitValue: number = 0;
  areaM2: number = 0;
  rentalUnitId: number = 0;
  compromiseDate: Date = new Date;
  createDate: Date = new Date;
  userNameCreate: string = '';
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
  costCenterPrice: CostCenterPriceModel | null = null;
  workshopStock: number = 0;
  shopStock: number = 0;
  reservedStock: number = 0;
  availableStock: number = 0;
  quotationId: number | null = null;
  swInvoiceM2: boolean = false;
  isOrderAdjustment: boolean = false;
} 